export function bindArgs<A extends readonly unknown[], R>(
  handler: (...args: A) => R,
  ...args: A
): () => R {
  return () => handler(...args);
}

export function identity<T>(value: T): T {
  return value;
}

export function noop(): void {
  // @no-action
}
